(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
(function() {
  // Set scroll speed
  var marquee = document.querySelector('.announcement-marquee');
  if (marquee) {
    var speed = marquee.getAttribute('data-scroll-speed');
    if (speed) {
      marquee.style.setProperty('--scroll-speed', speed + 's');
    } else {
      marquee.style.setProperty('--scroll-speed', '15s');
    }
  }
  
  // Double the content for seamless scroll
  var track = document.querySelector('.announcement-marquee__track');
  if (track) {
    var content = track.innerHTML;
    track.innerHTML = content + content;
  }
  
  // Close button
  var closeBtn = document.querySelector('.btn-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      var topbar = this.closest('.topbar');
      if (topbar) {
        topbar.style.display = 'none';
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
